<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
        <TagsView />
      </div>
      <app-main />
      <footer class="layout-footer">
        <p>
          Copyright © 2023-present
          <a href="www.8218ai.com" target="__blank" class="hover:underline color-primary">
            浙江八爪鱼数字科技有限公司版权所有
          </a>
        </p>
        <p class="ml8">
          <a href="http://beian.miit.gov.cn/" target="__blank" class="hover:underline color-primary">
            浙ICP备2022016657号
          </a>
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}

.sidebar-container {
  background: url("~@/assets/img/menu-bg.png") center no-repeat;
  background-size: 100% 100%;
}

.layout-footer {
  line-height: 20px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  color: #6a6a6a;
  position: sticky;
  bottom: 0;
  background-color: #fff;

  a {
    color: $--color-primary;

    &:hover {
      text-decoration: underline;
    }
  }
}

::v-deep {
  .el-scrollbar .scrollbar-wrapper {
    padding: 0 20px 20px 20px;
  }
}
</style>
